// extracted by mini-css-extract-plugin
export default {"wrapper":"tab-terms-of-service_wrapper__VvT4m","text":"tab-terms-of-service_text__0Quid","title":"tab-terms-of-service_title__6Hdxv"};